var React = require('react');

function IconLinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.45 6.897a3.448 3.448 0 113.446-3.45v.002a3.452 3.452 0 01-3.445 3.448zM6.48 26H.413V8.355h6.069v17.642L6.479 26zm8.498 0H8.92V8.355h5.85v1.511a6.126 6.126 0 014.595-1.928c5.893 0 6.687 4.258 6.687 8.424v9.635H19.99v-8.588c0-2.28-.161-4.039-2.294-4.039-1.954 0-2.713 1.091-2.713 3.892v8.735l-.005.003z","fill":"#2777b8","fillRule":"evenodd"}));
}

IconLinkedinInline.defaultProps = {"viewBox":"0 0 27 26"};

module.exports = IconLinkedinInline;

IconLinkedinInline.default = IconLinkedinInline;
